import React from "react";

import { Flex, Select, SelectProps } from "antd";

import { Icon } from "components";

export interface SelectSegmentedProps extends Omit<SelectProps, "optionRender"> {
  options: { label: string; value: string | number }[];
}

export const SelectSegmented = ({ className, ...props }: SelectSegmentedProps) => (
  <div className={`${className ?? ""}`}>
    <Select
      className="select-segmented"
      {...props}
      optionRender={(ori) => (
        <Flex align="center" justify="flex-start" className="select-segmented-option" gap={4}>
          {ori.label} {ori.value === props.value ? <Icon iconName={"tabler/circle-check"} /> : null}
        </Flex>
      )}
    />
  </div>
);
